<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mDesking/mPortal Settings Differences</strong>
        </div>

        <b-row>
          <b-col md="10">

              <b-card no-body>
                <div slot="header" v-b-toggle.mdesking>
                  <strong>mDesking Settings </strong>
                  <div class="card-actions">
                    <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                  </div>
                </div>
                <b-collapse id="mdesking">

                    <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                      <thead class="thead-light">
                        <tr>
                          <th aria-colindex="1">Id</th>
                          <th aria-colindex="2" style="width:20%;">Group</th>
                          <th aria-colindex="3" style="width:20%;">Setting</th>
                          <th aria-colindex="4" style="width:10%;">Code</th>
                          <th aria-colindex="5" style="width:10%;">mDesking</th>
                          <th aria-colindex="6" style="width:10%;">mPortal</th>
                          <th aria-colindex="7" style="width:5%;">Diff</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="!settings.length" class="b-table-empty-row">
                          <td colspan="7"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                        </tr>
                        <tr v-for="(item, index) in settings">
                          <td>{{index}}</td>
                          <td>{{ item.groupname }}</td>
                          <td>{{ item.name }}</td>
                          <td>mdesking: {{ item.code }} <br /> api: {{ item.key }}</td>
                          <td>{{ item.mdesking }}</td>
                          <td>{{ item.api }}</td>
                          <td>{{ item.diff }}</td>
                        </tr>
                      </tbody>
                    </table>

                </b-collapse>
                </b-card>

            <b-card no-body>
              <div slot="header" v-b-toggle.apidefault>
                <strong>API Default </strong>
                <div class="card-actions">
                  <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="apidefault">
                <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="0">Id</th>
                      <th aria-colindex="2">Setting</th>
                      <th aria-colindex="3" style="width:10%;">mPortal</th>
                      <th aria-colindex="5" style="width:10%;">mDesking</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!apisettings.length" class="b-table-empty-row">
                      <td colspan="4"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                    </tr>
                    <tr v-for="(item, index) in apisettings">
                      <td>{{index}}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.api }}</td>
                      <td>{{ item.mdesking }}</td>

                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div slot="header" v-b-toggle.apicustomfee>
                <strong>API Custom Fee </strong>
                <div class="card-actions">
                  <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="apicustomfee">
                <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="0">Id</th>
                      <th aria-colindex="2">Setting</th>
                      <th aria-colindex="3" style="width:10%;">mPortal</th>
                      <th aria-colindex="5" style="width:10%;">mDesking</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!apicustomfees.length" class="b-table-empty-row">
                      <td colspan="4"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                    </tr>
                    <tr v-for="(item, index) in apicustomfees">
                      <td>{{index}}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.api }}</td>
                      <td>{{ item.mdesking }}</td>

                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div slot="header" v-b-toggle.mdeskingcustomfee>
                <strong>mDesking Custom Fee </strong>
                <div class="card-actions">
                  <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="mdeskingcustomfee">
                <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="0">Id</th>
                      <th aria-colindex="2">Setting</th>
                      <!--<th aria-colindex="3" style="width:10%;">mPortal</th>-->
                      <th aria-colindex="5" style="width:10%;">mDesking</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!mdeskingfees.length" class="b-table-empty-row">
                      <td colspan="4"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                    </tr>
                    <tr v-for="(item, index) in mdeskingfees">
                      <td>{{index}}</td>
                      <td>{{ item.name }}</td>
                      <!--<td>{{ item.api }}</td>-->
                      <td>{{ item.mdesking }}</td>

                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div slot="header" v-b-toggle.apistatefee>
                <strong>API Default State Tax Fee :{{apistatetaxregion}} </strong>
                <div class="card-actions">
                  <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="apistatefee">
                <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="0">Id</th>
                      <th aria-colindex="2">Setting</th>
                      <th aria-colindex="3" style="width:10%;">mPortal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!apistatetax.length" class="b-table-empty-row">
                      <td colspan="4"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                    </tr>
                    <tr v-for="(item, index) in apistatetax">
                      <td>{{index}}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div slot="header" v-b-toggle.mdeskingbankfee>
                <strong>mDesking Bank Fee Markup</strong>
                <div class="card-actions">
                  <b-btn class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="mdeskingbankfee">
                <table aria-busy="false" class="table b-table table-striped table-bordered table-sm">
                  <thead class="thead-light">
                    <tr>
                      <th aria-colindex="0">Id</th>
                      <th aria-colindex="2">Setting</th>
                      <!--<th aria-colindex="3" style="width:10%;">mPortal</th>-->
                      <th aria-colindex="5" style="width:10%;">mDesking</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!mdeskingbankfees.length" class="b-table-empty-row">
                      <td colspan="4"><div role="alert" aria-live="polite"><div class="text-center my-2">No options loaded yet.</div></div></td>
                    </tr>
                    <tr v-for="(item, index) in mdeskingbankfees">
                      <td>{{index}}</td>
                      <td>{{ item.name }}</td>
                      <!--<td>{{ item.api }}</td>-->
                      <td>{{ item.mdesking }}</td>

                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </b-card>

          </b-col>
        </b-row>
      </b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    axios.get('/api/settingsdifferences/loaddata')
      .then(response => {
        this.boolLoading = false
        this.settings = response.data.mdeskingsettings
        this.apisettings = response.data.apisettings
        this.apicustomfees = response.data.apicustomfees
        this.apistatetaxregion = response.data.apistatetaxregion
        this.apistatetax = response.data.apistatetax
        this.mdeskingfees = response.data.mdeskingfees
        this.mdeskingbankfees = response.data.mdeskingbankfees
      })
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      settings: [],
      apisettings: [],
      apicustomfees: [],
      apistatetaxregion: '',
      apistatetax: [],
      mdeskingfees: [],
      mdeskingbankfees: []
    }
  },
  methods: {

    nullOnEmpty (o) {
      if (o.value == '') { o.value = null }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}

</script>



// WEBPACK FOOTER //
// src/views/SettingsDifferences.vue